// Find multiple options by their values (for multi-selects)
export function findOptionsByValues(options, values) {
  if (!Array.isArray(options) || !values) return [];
  const valueArray = Array.isArray(values)
    ? values
    : values.split(",").map((v) => v.trim());
  return valueArray
    .map((val) => options.find((opt) => String(opt.value) === String(val)))
    .filter(Boolean);
}

/**
 * Build filter data object from URL search params
 * Note: This returns only URL-derived filter data; caller should merge with
 * existing filterForm to preserve defaults (e.g., jobType: "TAP_UPDATE_ENGINE")
 * @param {Object} params - Parsed URL search params
 * @param {Array} jobStatusOptions - Available job status options
 * @returns {Object} Filter data object for the form
 */
export function buildFilterFromParams(params, jobStatusOptions) {
  const filterData = {};

  if (params.jobId) {
    filterData.jobId = params.jobId;
  }

  if (params.jobStatus && jobStatusOptions.length > 0) {
    filterData.jobStatus = findOptionsByValues(
      jobStatusOptions,
      params.jobStatus,
    );
  }

  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }

  return filterData;
}

// Serialize multi-select value to comma-separated string of IDs
function serializeMultiSelect(value) {
  if (!value || (Array.isArray(value) && value.length === 0)) return "";
  if (Array.isArray(value)) {
    return value.map((v) => v?.value ?? v).join(",");
  }
  return value?.value ?? value ?? "";
}

// Cleans the job filter object by removing empty or null values
export function cleanJobFilter(filter, updateEngineRange, updateEngineSort) {
  const filtered = {};

  // Text fields
  if (filter.jobId) filtered.jobId = filter.jobId;

  // Multi-select fields
  const jobStatusVal = serializeMultiSelect(filter.jobStatus);
  if (jobStatusVal) filtered.jobStatus = jobStatusVal;

  // Pagination
  filtered.updateEngineRange = updateEngineRange;
  filtered.updateEngineSort = updateEngineSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
